export interface Video {
  id: string;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  year: number;
  rating: number;
  description: string;
  tags: string[];
  views: number;
  updateDate: string;
  director?: string;
  actors?: string[];
  episodes?: number;
  featured?: boolean;
  isNew?: boolean;
  isHot?: boolean;
}

export const videos: Video[] = [
  {
    id: 'v001',
    title: '流浪地球3',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20Earth%20in%20space%2C%20dramatic%20lighting%2C%20cinematic%20epic%20vibe%2C%20clean%20background%20with%20stars%2C%20minimalist%20design%2C%20professional%20movie%20poster%20style&width=640&height=360&seq=thumb-v001&orientation=landscape',
    duration: '148分钟',
    year: 2026,
    rating: 8.7,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙之旅，年轻一代挺身而出，展开了争分夺秒的生死之战。本片为流浪地球系列第三部，延续了前作的宏大叙事与震撼视效。',
    tags: ['科幻', '冒险', '灾难', '国产'],
    views: 12580000,
    updateDate: '2026-08-01',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    featured: true,
    isHot: true,
  },
  {
    id: 'v002',
    title: '长安三万里2',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20Tang%20dynasty%20animated%20movie%20poster%20with%20poets%20and%20palace%2C%20warm%20golden%20tones%2C%20traditional%20Chinese%20painting%20style%2C%20elegant%20composition%2C%20soft%20lighting&width=640&height=360&seq=thumb-v002&orientation=landscape',
    duration: '168分钟',
    year: 2026,
    rating: 9.1,
    description: '安史之乱后，高适被困孤城，回忆与李白的一生友谊。从年少相识到各自闯荡，展现了盛唐时期诗人们的豪情壮志与人生起伏。影片以壮丽画面再现大唐风华。',
    tags: ['动画', '历史', '诗词', '国产'],
    views: 8930000,
    updateDate: '2026-07-28',
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫'],
    featured: true,
    isHot: true,
  },
  {
    id: 'v003',
    title: '狂飙',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20TV%20drama%20poster%2C%20dark%20moody%20atmosphere%2C%20police%20and%20criminal%20theme%2C%20professional%20cinematic%20lighting%2C%20intense%20dramatic%20tone%2C%20minimalist%20design&width=640&height=360&seq=thumb-v003&orientation=landscape',
    duration: '45分钟/集',
    year: 2023,
    rating: 9.4,
    description: '以一线刑警安欣为代表的正义力量，与黑恶势力展开长达二十年的殊死搏斗。通过群像叙事展现扫黑除恶过程中的复杂人性与惊心动魄。',
    tags: ['犯罪', '悬疑', '剧情', '国产'],
    views: 35600000,
    updateDate: '2026-07-15',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    episodes: 39,
    isHot: true,
  },
  {
    id: 'v004',
    title: '奔跑吧·第12季',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20celebrities%20running%20and%20laughing%2C%20bright%20colorful%20design%2C%20energetic%20vibe%2C%20outdoor%20adventure%20theme%2C%20fun%20and%20dynamic%20composition&width=640&height=360&seq=thumb-v004&orientation=landscape',
    duration: '90分钟/期',
    year: 2026,
    rating: 8.2,
    description: '全新一季奔跑吧重磅回归！常驻嘉宾携手飞行嘉宾，在全国各地展开趣味横生的任务挑战。笑料不断，惊喜连连，每周为您带来欢乐时光。',
    tags: ['真人秀', '搞笑', '竞技', '户外'],
    views: 18200000,
    updateDate: '2026-08-05',
    episodes: 12,
    isNew: true,
  },
  {
    id: 'v005',
    title: '哪吒之魔童闹海',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20animated%20movie%20poster%20featuring%20Nezha%20character%20with%20fire%20wheels%2C%20epic%20battle%20scene%2C%20vibrant%20red%20and%20gold%20colors%2C%20traditional%20Chinese%20art%20style&width=640&height=360&seq=thumb-v005&orientation=landscape',
    duration: '135分钟',
    year: 2025,
    rating: 9.2,
    description: '天劫之后，哪吒与敖丙虽保住了灵魂但肉身面临消散。太乙真人试图用七色宝莲为二人重塑肉身，然而在过程中遇到了重重困难，一场更大的危机正在酝酿。',
    tags: ['动画', '神话', '奇幻', '国产'],
    views: 42600000,
    updateDate: '2026-06-20',
    director: '饺子',
    featured: true,
    isHot: true,
  },
  {
    id: 'v006',
    title: '庆余年·第二季',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%20with%20ancient%20palace%20and%20warrior%2C%20elegant%20traditional%20style%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C0rich%20textures&width=640&height=360&seq=thumb-v006&orientation=landscape',
    duration: '45分钟/集',
    year: 2024,
    rating: 9.0,
    description: '范闲在经历生死考验后，回到京都面对更加复杂的政治局势。各方势力暗流涌动，一段关于权力、爱情与理想的传奇故事继续上演。',
    tags: ['古装', '权谋', '爱情', '国产'],
    views: 28900000,
    updateDate: '2026-07-10',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明'],
    episodes: 36,
    isHot: true,
  },
  {
    id: 'v007',
    title: '蓝色星球·第三季',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ocean%20wildlife%20documentary%20poster%20with%20whales%20and%20coral%20reefs%2C%20deep%20blue%20underwater%20scene%2C%20crystal%20clear%20water%2C%20professional%20nature%20photography%2C%20serene%20atmosphere&width=640&height=360&seq=thumb-v007&orientation=landscape',
    duration: '50分钟/集',
    year: 2026,
    rating: 9.7,
    description: 'BBC金牌团队历时四年拍摄，深入全球各大洋，以前所未有的视角展现海洋世界的壮美与神秘。从极地冰海到热带珊瑚礁，每一帧都是视觉盛宴。',
    tags: ['自然', '海洋', 'BBC', '纪录片'],
    views: 5670000,
    updateDate: '2026-08-02',
    episodes: 8,
    isNew: true,
  },
  {
    id: 'v008',
    title: 'NBA总决赛·2026',
    category: 'tiyu',
    thumbnail: 'https://readdy.ai/api/search-image?query=NBA%20basketball%20finals%20poster%20with%20players%20dunking%2C%20intense%20arena%20atmosphere%2C%20dramatic%20lighting%2C%20sports%20photography%20style%2C%20dynamic%20action%20shot&width=640&height=360&seq=thumb-v008&orientation=landscape',
    duration: '120分钟',
    year: 2026,
    rating: 9.3,
    description: '2026年NBA总决赛全程高清回放！精彩对决、绝杀时刻、球星高光表现一网打尽。篮球迷不可错过的年度盛宴。',
    tags: ['篮球', 'NBA', '赛事', '体育'],
    views: 12300000,
    updateDate: '2026-06-20',
    isHot: true,
  },
  {
    id: 'v009',
    title: '封神·第二部',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20fantasy%20movie%20poster%20with%20gods%20and%20warriors%2C%20epic%20battle%20scene%2C%20ancient%20Chinese%20aesthetic%2C%20dramatic%20composition%2C%20golden%20and%20crimson%20tones&width=640&height=360&seq=thumb-v009&orientation=landscape',
    duration: '152分钟',
    year: 2025,
    rating: 8.5,
    description: '西岐之战后，姬发率军东征。闻仲大军压境，姜子牙布阵迎敌。一场关乎天下归属的终极之战就此展开。宏大的战争场面与细腻的人物刻画，续写东方神话史诗。',
    tags: ['奇幻', '神话', '战争', '国产'],
    views: 15600000,
    updateDate: '2026-05-15',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '陈坤'],
    featured: true,
  },
  {
    id: 'v010',
    title: '向往的生活·第八季',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20slow-life%20variety%20show%20poster%20with%20countryside%20farmhouse%2C%20warm%20cozy%20atmosphere%2C%20green%20nature%20background%2C%20relaxing%20rural%20life%20vibe&width=640&height=360&seq=thumb-v010&orientation=landscape',
    duration: '80分钟/期',
    year: 2026,
    rating: 8.8,
    description: '远离城市喧嚣，回归田园生活。常驻嘉宾在小院中迎接八方来客，一日三餐、劳作闲聊，展现最真实质朴的生活之美。',
    tags: ['慢综艺', '生活', '美食', '田园'],
    views: 13400000,
    updateDate: '2026-08-03',
    episodes: 14,
    isNew: true,
  },
  {
    id: 'v011',
    title: '名侦探柯南·最新剧场版',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20mystery%20anime%20movie%20poster%20with%20detective%20character%2C%20dark%20suspenseful%20atmosphere%2C%20magnifying%20glass%20and%20clues%2C%20professional%20anime%20art%20style%2C%20cool%20composition&width=640&height=360&seq=thumb-v011&orientation=landscape',
    duration: '110分钟',
    year: 2026,
    rating: 8.9,
    description: '柯南与少年侦探团遭遇全新案件！一枚神秘的蓝宝石引发多方势力争夺，隐藏在背后的惊天阴谋逐渐浮出水面。智慧与勇气的巅峰对决！',
    tags: ['日漫', '推理', '悬疑', '剧场版'],
    views: 9870000,
    updateDate: '2026-07-22',
    isHot: true,
  },
  {
    id: 'v012',
    title: '地球脉动·第四季',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Nature%20wildlife%20documentary%20poster%20with%20mountains%20and%20animals%2C%20epic%20landscape%20photography%2C%20golden%20hour%20lighting%2C%20majestic%20natural%20scenery%2C%20professional%20BBC%20style&width=640&height=360&seq=thumb-v012&orientation=landscape',
    duration: '55分钟/集',
    year: 2026,
    rating: 9.8,
    description: '从最高的山峰到最深的海洋，从最寒冷的极地到最炎热的沙漠。大卫·爱登堡爵士带您领略地球上最壮观的自然奇观与野生动物的生存智慧。',
    tags: ['自然', '动物', 'BBC', '纪录片'],
    views: 12340000,
    updateDate: '2026-07-30',
    episodes: 6,
    featured: true,
    isNew: true,
  },
];

export const getVideosByCategory = (categorySlug: string): Video[] => {
  return videos.filter((v) => v.category === categorySlug);
};

export const getFeaturedVideos = (): Video[] => {
  return videos.filter((v) => v.featured);
};

export const getHotVideos = (): Video[] => {
  return videos.filter((v) => v.isHot);
};

export const getNewVideos = (): Video[] => {
  return videos.filter((v) => v.isNew);
};

export const getRelatedVideos = (videoId: string, category: string): Video[] => {
  return videos.filter((v) => v.id !== videoId && v.category === category).slice(0, 4);
};